import React, { useEffect, useRef, useState } from "react";

/** 내부용: 로딩 종료 뒤에도 minDuration 만큼은 유지 */
function useMinDelay(isOn, minDuration = 900) {
  const [visible, setVisible] = useState(isOn);
  const tRef = useRef(null);

  useEffect(() => {
    if (isOn) {
      if (tRef.current) clearTimeout(tRef.current);
      tRef.current = null;
      setVisible(true);
    } else {
      tRef.current = setTimeout(() => setVisible(false), minDuration);
      return () => {
        if (tRef.current) clearTimeout(tRef.current);
      };
    }
  }, [isOn, minDuration]);

  return visible;
}

/**
 * 통합 로더
 * - mode: 'fullscreen' | 'block' (디폴트 'block')
 * - loading: true/false (필수)
 * - message: 표시 문구
 * - minDuration: 최소 표시 시간(ms)
 * - minHeight: block 모드에서 카드 높이
 * - backdrop: fullscreen 모드에서 배경 오버레이/블러 사용 여부
 */
export default function Loader({
  mode = "block",
  loading = false,
  message = "불러오는 중…",
  minDuration = 900,
  minHeight = "min-h-[140px]",
  backdrop = true,
  className = "",
}) {
  const show = useMinDelay(loading, minDuration);
  if (!show) return null;

  const isFull = mode === "fullscreen";

  const wrapperCls = isFull
    ? [
        "fixed inset-0 z-50 flex items-center justify-center",
        backdrop ? "bg-white/60 dark:bg-zinc-900/50 backdrop-blur-[2px]" : "",
        className,
      ].join(" ")
    : [
        "flex items-center justify-center",
        "bg-white dark:bg-zinc-900 p-6",
        minHeight,
        className,
      ].join(" ");

  return (
    <div className={wrapperCls} role="status" aria-busy="true" aria-live="polite">
      <div className="flex flex-col items-center gap-3 pt-1">
        {/* 예쁜 스피너 (이중 링 + 글로우) */}
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-2 border-zinc-200 dark:border-zinc-800" />
          <div className="absolute inset-0 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" />
          <div className="absolute -inset-1 rounded-full bg-indigo-500/15 blur-md animate-pulse" />
        </div>

        {!!message && (
          <div className="text-sm font-medium text-zinc-600 dark:text-zinc-300">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
